import React from 'react'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom'
const ComingSoon = () => {
  return (
     <>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>  
                 <li>ComingSoon</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Coming Soon  </h1>
                    </div>
                </div>
                <div className="row">
                      <div className="col-lg-12">
                           <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STFSR/public/Images/comingsoon.jpg" className="img-fluid cmimg" alt=" St. Francis School  Harmu, Ranchi " /></LazyLoad>
                      </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default ComingSoon

